//===================================================================
// Literature Display Style
//===================================================================
// Keep as HTMLCollections
if (document.getElementsByClassName('plauditQueryLoop--literature').length > 0) {
	const literatureTabs = document.getElementsByClassName('layoutType__trigger');
	const literatureMain = document.getElementsByClassName('plauditQueryLoop__main');
	setActiveTab(localStorage.getItem('activeLiteratureTab') || 'list');

	// Set active tab
	function setActiveTab(tab: string) {
		// Remove active class
		for (const t of literatureTabs) {
			t.classList.remove('active');
		}

		const style = `layoutType--${tab}`;
		for (const main of literatureMain) {
			for (const cn of Array.from(main.classList.values()).filter(cn => cn.startsWith("layoutType--"))) {
				main.classList.remove(cn);
			}
			main.classList.toggle(style, true);
		}

		literatureTabs.namedItem(tab)?.classList.toggle('active', true);
		localStorage.setItem('activeLiteratureTab', tab);
	}

	// Tab click handler
	for (const tab of literatureTabs) {
		tab.addEventListener('click', () => {
			setActiveTab(tab.id);
		});
	}
}
